import { Box, Grid, Image, NavLink, Text } from '@mantine/core'
import { IconChevronRight } from '@tabler/icons'
import Link from 'next/link'
import { useRouter } from 'next/router'

import {
  Collection as CollectionType,
  Product as ProductType,
  Showcase as ShowcaseType,
  Site as SiteType,
  Store as StoreType
} from '@/types'

import ProductCard from './ProductCard'

interface Props {
  site?: SiteType
  store?: StoreType
  showcase?: ShowcaseType
  collections: CollectionType[]
  products: ProductType[]
  search?: string
}

export default function CollectionsDisplay({
  site,
  store,
  showcase,
  collections,
  products,
  search
}: Props) {
  const router = useRouter()

  // Constants
  const {
    channel: channelSlug,
    store: storeSlug,
    showcase: showcaseSlug,
    collection: collectionSlug
  } = router.query || {}
  const hasCollections = Array.isArray(collections) && !!collections.length

  return (
    <Grid gutter="lg">
      <Grid.Col span={12} sm={4} md={3} lg={2} hidden={!!search}>
        <Box sx={{ position: 'sticky', top: '175px' }}>
          {hasCollections && (
            <Text weight={700} mb="sm">
              Coleções
            </Text>
          )}
          {collections?.map(collection => (
            <NavLink
              key={collection.uid}
              label={<Text sx={{ lineHeight: 1.2 }}>{collection.displayName}</Text>}
              icon={
                collection.image && (
                  <Image src={collection.image} alt={collection.displayName} width={32} />
                )
              }
              rightSection={<IconChevronRight size={16} stroke={1.5} />}
              active={collection.slug === collectionSlug}
              component={Link}
              href={`/${channelSlug}/${storeSlug}/${showcaseSlug}?collection=${collection.slug}`}
            />
          ))}
        </Box>
      </Grid.Col>
      <Grid.Col span={12} sm={search ? 12 : 8} md={search ? 12 : 9} lg={search ? 12 : 10}>
        {Array.isArray(products) && !!products?.length && (
          <Grid gutter="lg">
            {products.map((product: any) => (
              <Grid.Col key={product?.uid} span={12} xs={6} md={4} lg={12 / 5}>
                <ProductCard product={product} site={site} store={store} showcase={showcase} />
              </Grid.Col>
            ))}
          </Grid>
        )}
      </Grid.Col>
    </Grid>
  )
}
